import { throttle } from 'lodash';
import { useEffect, useState } from 'react';
import { Breakpoint } from './breakpoint';
export const calculateBreakpoint = (width) => {
    if (width < Breakpoint.sm) {
        return Breakpoint.xs;
    }
    else if (width >= Breakpoint.sm && width < Breakpoint.md) {
        return Breakpoint.sm;
    }
    else if (width >= Breakpoint.md && width < Breakpoint.lg) {
        return Breakpoint.md;
    }
    else if (width >= Breakpoint.lg && width < Breakpoint.xl) {
        return Breakpoint.lg;
    }
    else {
        return Breakpoint.xl;
    }
};
export const useBreakpoint = () => {
    const [breakpoint, setBreakpoint] = useState(() => calculateBreakpoint(window.innerWidth));
    useEffect(() => {
        const throttledGetScreenSize = throttle(() => {
            setBreakpoint(calculateBreakpoint(window.innerWidth));
        }, 200);
        window.addEventListener('resize', throttledGetScreenSize);
        return () => window.removeEventListener('resize', throttledGetScreenSize);
    }, []);
    return breakpoint;
};
